import { PlayerStates } from 'data/VideoPlayer'
import PlayerWrapperWithPoster from 'components/set/InteractionPlayer/PlayerWrapperWithPoster/PlayerWrapperWithPoster'
import React from 'react'
import { Show } from 'data/Show'

export const LiveStreamIdle: React.FC<{ show: Show }> = ({ show }) => (
    <PlayerWrapperWithPoster posterImg={show.posterImg} stateId={`${PlayerStates.LIVE}_idle`} />
)

export default React.memo(LiveStreamIdle)
